import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { composeValidators, required, validPercentage, positiveNumber } from '../../../forms';
import PercentInput from '../../../forms/PercentInput';
import moment from 'moment';
import { DateRangePicker, SingleDatePicker,isInclusivelyBeforeDay } from 'react-dates';

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);

const formatDate = value => {
  return moment(value);
};
const normalizeDate = value => {
  // if (value.value) {
  //    if (moment.isMoment(value.value)) {
  //      return value.value.format('YYYY-MM-DD');
  //    }
  //  }
  console.log('date =' + value.format('YYYY-MM-DD'));
  if (moment.isMoment(value)) {
    return value.format('YYYY-MM-DD');
  }
  return value;
};

const normalizeDate1 = value => {
  if (Object.prototype.hasOwnProperty.call(value, 'value')) {
    return value.value.format('YYYY-MM-DD');
  }
  if (moment.isMoment(value)) {
    return value.format('YYYY-MM-DD');
  }
  return value;
};

const renderDate = ({ input, label, type, meta: { active, touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <br />
    <SingleDatePicker
      date={input.value}
      focused={active}
      isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
      onDateChange={value => {
        input.onChange(value);
      }}
      onFocusChange={({ focused }) => {
        if (focused) {
          return input.onFocus();
        }
        return input.onBlur();
      }}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
  </InputGroup>
);

const RenderSelectInput = ({
  input,
  options,
  name,
  id,
  label,
  readOnly,
  help,
  meta: { active, touched, error, warning },
}) => (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <Select
        id={id}
        name={name}
        options={options}
        readOnly={readOnly}
        value={input.value}
        onChange={value => {
          input.onChange(value.value);
        }}
        onBlur={value => input.onBlur(value.value)}
        joinValues
      />
      {help && <HelpBlock>{help}</HelpBlock>}
      {touched &&
        ((error && <p className="alert alert-danger">{error}</p>) ||
          (warning && <p className="alert alert-warning">{warning}</p>))}
    </FormGroup>
  );
//GBP, EURO, AUD, JPY, CNY
const currencyOptions = [
  {
    label: '🇦🇺 AUD - Australian Dollar',
    value: 'AUD',
  },
  {
    label: '🇨🇦 CAD - Canadian Dollar',
    value: 'CAD',
  },
  {
    label: '🇨🇳 CNY - Chinese Yuan Renminbi',
    value: 'CNY',
  },
  {
    label: '🇪🇺 EUR - Euro',
    value: 'EUR',
  },
  {
    label: '🇬🇧 GBP - British Pound',
    value: 'GBP',
  },
  {
    label: '🇯🇵 JPY - Japanese Yen',
    value: 'JPY',
  },
  {
    label: '🇲🇽 MXN - Mexican Peso',
    value: 'MXN',
  },
  {
    label: '🇺🇸 USD - US Dollar',
    value: 'USD',
  },
  {
    label: '🇳🇿 ZND - New Zealand Dollar',
    value: 'ZND',
  },
  {
    label: '🇧🇷 BRL - Brazilian Real',
    value: 'BRL',
  },
  {
    label: '🇦🇷 ARS - Argentinian peso',
    value: 'ARS',
  },
  {
    label: '🇨🇱 CLP - Chilean Peso',
    value: 'CLP',
  },
  {
    label: '🇩🇰 DKK - Danish Krone',
    value: 'DKK',
  },
  {
    label: '🇮🇳 INR - Indian Rupee',
    value: 'INR',
  },
  {
    label: '🇰🇷 KRW - Korean Won',
    value: 'KRW',
  },
  {
    label: '🇳🇴 NOK - Norwegian Krone',
    value: 'NOK',
  },
  {
    label: '🇷🇺 RUB - Russian Ruble',
    value: 'RUB',
  },
  {
    label: '🇨🇭 CHF - Swiss Franc',
    value: 'CHF',
  },
  {
    label: '🇦🇪 AED - UAE Dirham',
    value: 'AED',
  },
  {
    label: '🇿🇦 ZAR - South African Rand',
    value: 'ZAR',
  },
  {
    label: '🇮🇸 ISK - Icelandic Krona',
    value: 'ISK',
  },
  {
    label: '🇮🇱 ILS - Israel new Shekel',
    value: 'ILS',
  },
  {
    label: '🇵🇱 PLN - Polish Zloty',
    value: 'PLN',
  },
  {
    label: '🇶🇦 QAR - Qatari Riyal',
    value: 'QAR',
  },
  {
    label: '🇹🇷 TRY - Turkish Lira',
    value: 'TRY',
  },
  {
    label: '🇸🇪 SEK - Swedish krona',
    value: 'SEK',
  },
];

const hourOptions = [
  {
    label: '10:00 am',
    value: '10:00:00',
  },
  {
    label: '10:30 am',
    value: '10:30:00',
  },
  {
    label: '11:00 am',
    value: '11:00:00',
  },
  {
    label: '11:30 am',
    value: '11:30:00',
  },
  {
    label: '12:00 pm',
    value: '12:00:00',
  },
  {
    label: '12:30 pm',
    value: '12:30:00',
  },
  {
    label: '1:00 pm',
    value: '13:00:00',
  },
  {
    label: '2:00 pm',
    value: '14:00:00',
  },
  {
    label: '3:00 pm',
    value: '15:00:00',
  },
  {
    label: '3:30 pm',
    value: '15:30:00',
  },
  {
    label: '4:00 pm',
    value: '16:00:00',
  },
  {
    label: '4:30 pm',
    value: '16:30:00',
  },
  {
    label: '5:00 pm',
    value: '17:00:00',
  },
];

const hour24Options = [
  {
    label: '00:00 am',
    value: '00:00:00',
  },
  {
    label: '00:30 am',
    value: '00:30:00',
  },
  {
    label: '01:00 am',
    value: '01:00:00',
  },
  {
    label: '01:30 am',
    value: '01:30:00',
  },
  {
    label: '02:00 am',
    value: '02:00:00',
  },
  {
    label: '02:30 am',
    value: '02:30:00',
  },
  {
    label: '03:00 am',
    value: '03:00:00',
  },
  {
    label: '03:30 am',
    value: '03:30:00',
  },
  {
    label: '04:00 am',
    value: '04:00:00',
  },
  {
    label: '04:30 am',
    value: '04:30:00',
  },
  {
    label: '05:00 am',
    value: '05:00:00',
  },
  {
    label: '05:30 am',
    value: '05:30:00',
  },
  {
    label: '06:00 am',
    value: '06:00:00',
  },
  {
    label: '06:30 am',
    value: '06:30:00',
  },
  {
    label: '07:00 am',
    value: '07:00:00',
  },
  {
    label: '07:30 am',
    value: '07:30:00',
  },
  {
    label: '08:00 am',
    value: '08:00:00',
  },
  {
    label: '08:30 am',
    value: '08:30:00',
  },
  {
    label: '09:00 am',
    value: '09:00:00',
  },
  {
    label: '09:30 am',
    value: '09:30:00',
  },
  {
    label: '10:00 am',
    value: '10:00:00',
  },
  {
    label: '10:30 am',
    value: '10:30:00',
  },
  {
    label: '11:00 am',
    value: '11:00:00',
  },
  {
    label: '11:30 am',
    value: '11:30:00',
  },
  {
    label: '12:00 pm',
    value: '12:00:00',
  },
  {
    label: '12:30 pm',
    value: '12:30:00',
  },
  {
    label: '01:00 pm',
    value: '13:00:00',
  },
  {
    label: '01:30 pm',
    value: '13:30:00',
  },
  {
    label: '02:00 pm',
    value: '14:00:00',
  },
  {
    label: '02:30 pm',
    value: '14:30:00',
  },
  {
    label: '03:00 pm',
    value: '15:00:00',
  },
  {
    label: '03:30 pm',
    value: '15:30:00',
  },
  {
    label: '04:00 pm',
    value: '16:00:00',
  },
  {
    label: '04:30 pm',
    value: '16:30:00',
  },
  {
    label: '05:00 pm',
    value: '17:00:00',
  },
  {
    label: '17:30 pm',
    value: '17:30:00',
  },
  {
    label: '06:00 pm',
    value: '18:00:00',
  },
  {
    label: '06:30 pm',
    value: '18:30:00',
  },
  {
    label: '07:00 pm',
    value: '19:00:00',
  },
  {
    label: '07:30 pm',
    value: '19:30:00',
  },
  {
    label: '08:00 pm',
    value: '20:00:00',
  },
  {
    label: '08:30 pm',
    value: '20:30:00',
  },
  {
    label: '09:00 pm',
    value: '21:00:00',
  },
  {
    label: '09:30 pm',
    value: '21:30:00',
  },
  {
    label: '10:00 pm',
    value: '22:00:00',
  },
  {
    label: '10:30 pm',
    value: '22:30:00',
  },
  {
    label: '11:00 pm',
    value: '23:00:00',
  },
  {
    label: '11:30 pm',
    value: '23:30:00',
  },
];

const parkingchargesOptions = [
  {
    label: 'per day',
    value: '1'
  },
  {
    label: 'per night',
    value: '2'
  }
]

const starOptions = [
  {
    label: '⭐',
    value: '1',
  },
  {
    label: '⭐⭐',
    value: '2',
  },
  {
    label: '⭐⭐⭐',
    value: '3',
  },
  {
    label: '⭐⭐⭐⭐',
    value: '4',
  },
  {
    label: '⭐⭐⭐⭐⭐',
    value: '5',
  },
];

const PropertyDetailsForm = ({ onSubmit, initialValues, options, handleClose, restaurantDisableClassName, handleRestaurantDisable, handleBarDisable, handleGymDisable, handleRoomServiceDisable, gymDisableClassName, barDisableClassName, roomServiceDisableClassName}) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!values.name) {
        //errors.FORM_ERROR = 'Hotel name must not be blank.';
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12 hotel-details-description">
            <h4 className="hotel-highlight">Details</h4>
          </div>
          <div className="col-md-4">
            <FormGroup>
              <Field
                name="stars"
                component={RenderSelectInput}
                label="AAA Rating"
                options={starOptions}
              />
              <Field
                name="check_in"
                component={RenderSelectInput}
                options={hourOptions}
                label="Check-in Time"
              />
              <Field
                name="check_out"
                component={RenderSelectInput}
                options={hourOptions}
                label="Check-out Time"
              />
              
              <Field name="room_count" component={renderTextField} validate={composeValidators(required)} type="number" pattern="[0-9]*" inputmode="numeric" label="Number of Rooms"/>
              <Error name="room_count" />
              <Field name="floors" component={renderTextField} validate={composeValidators(required)} type="number" pattern="[0-9]*" inputmode="numeric" label="Number of Floors"/>
              <Error name="floors" />
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup>
              <Field
                name="currency"
                component={RenderSelectInput}
                label="Currency"
                options={currencyOptions}
              />
              <Field
                name="tax_rate"
                component={PercentInput}
                placeholder="12.0%"
                type="number"
                step="0.1"
                label="Tax Rate"
                validate={composeValidators(required, validPercentage)}
              />
              <Error name="tax_rate" />
              <Field name="additional_tax" component={renderTextField} type="number" step="0.1" label="Additional Tax(per day)" />
                  <Error name="additional_tax" />
              <Field name="resort_fee" component={renderTextField} type="number" step="0.1" label="Resort Fee(per day)" validate={composeValidators(required)}/>
              <Error name="resort_fee" />
  
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup>
              <Field
                  label="Date Built"
                  name="year_built"
                  component={renderDate}
                  normalize={normalizeDate}
                  format={formatDate}
                />
                <Field
                  label="Date Remodeled"
                  name="year_remodeled"
                  component={renderDate}
                  normalize={normalizeDate}
                  format={formatDate}
                />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <h4 className="hotel-highlight">Restaurant Hours</h4>
            <FormGroup>
            <div className="opening-hours-checkbox-field">
              <Field
                name="is_24hours_restaurant"
                type="checkbox"
                component="input"
                onClick={handleRestaurantDisable}
              />
              24 Hours
              </div>
              <div className={restaurantDisableClassName}>
              <Field
                name="restaurant_from_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="From"
              />
              <Field
                name="restaurant_to_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="To"
              />
            </div>
            </FormGroup>
          </div>
          <div className="col-md-4">
            <h4 className="hotel-highlight">Bar Hours</h4>
            <FormGroup>
            <div className="opening-hours-checkbox-field">
              <Field
                name="is_24hours_bar"
                type="checkbox"
                component="input"
                onClick={handleBarDisable}
              />
              24 Hours
              </div>
              <div className={barDisableClassName}>
              <Field
                name="bar_from_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="From"
              />
              <Field
                name="bar_to_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="To"
              />
              </div>
            </FormGroup>
          </div>
          <div className="col-md-4">
            <h4 className="hotel-highlight">Gym Hours</h4>
            <FormGroup>
            <div className="opening-hours-checkbox-field">
              <Field
                name="is_24hours_gym"
                type="checkbox"
                component="input"
                onClick={handleGymDisable}
              />
              24 Hours
              </div>
              <div className={gymDisableClassName}>
              <Field
                name="gym_from_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="From"
              />
              <Field
                name="gym_to_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="To"
              />
              </div>
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <h4 className="hotel-highlight">Room Service Hours</h4>
            <FormGroup>
            <div className="opening-hours-checkbox-field">
            <Field
                name="is_24hours_room_service"
                type="checkbox"
                component="input"
                onClick={handleRoomServiceDisable}
              />
              24 Hours
              </div>
              <div className={roomServiceDisableClassName}>
              <Field
                name="room_service_from_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="From"
              />
              <Field
                name="room_service_to_time"
                component={RenderSelectInput}
                options={hour24Options}
                label="To"
              />
              </div>
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <FormGroup>
              <h4 className="hotel-highlight">Bus Parking</h4>
              <Field
                name="bus_capacity"
                component={renderTextField}
                placeholder="0"
                label="Number of Buses"
              />
              <div className="row">
                <div className="col-md-4">
                  <Field
                    name="parking_charges"
                    component={renderTextField}
                    placeholder=""
                    label="Parking Charges"
                    type="number" 
                    step="0.1"
                  />
                </div>
                <div className="col-md-4">  
                  <Field
                    name="per_day_night"
                    component={RenderSelectInput}
                    options={parkingchargesOptions}
                    label="Parking Charges per"
                  />
                </div>  
              </div>
              <Field
                name="bus_parking"
                component={renderTextField}
                placeholder="Please enter notes about the bus parking. Cost per bus. If offsite, how far way."
                label="Parking Notes"
              />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
            <FormGroup>
              <ButtonToolbar>
                <Button disabled={pristine || submitting} bsStyle="success" type="submit">
                  Save
                </Button>
                <Button disabled={submitting} bsStyle="success" onClick={handleClose}>
                  Cancel
                </Button>
              </ButtonToolbar>
            </FormGroup>
          </div>
        </div>
      </form>
    )}
  />
);

export default PropertyDetailsForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDetailsForm.js